import { CREATE, UPDATE } from '@/state/types/data'

const mapFields = {
  products: 'logo',
  users: 'picture',
  contacts: 'picture',
}
/** CREATE,
 * Convert a `File` object returned by the upload input into
 * a base 64 string.
 */
const convertFileToBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file.rawFile)

    reader.onload = () => resolve({ src: reader.result, title: file.title, rawFile: file.rawFile })
    reader.onerror = reject
  })

/**
* For products update only, convert uploaded image in base 64 and attach it to
* the `logo` sent property, with `src` and `title` attributes.
*/
const addUploadFeature = requestHandler => (type, resource, params) => {
  if (type === UPDATE || type === CREATE) {
    if (mapFields[resource]) {
      const field = mapFields[resource]
      if (params.data[field] && Array.isArray(params.data[field]) && params.data[field].length) {
        const { [field]: image, ...data } = params.data
        // make sure logo is instance of a File
        const newImage = image.filter(p => p.rawFile instanceof File).shift()

        return convertFileToBase64(newImage).then(base64Image =>
          requestHandler(type, resource, {
            ...params,
            data: {
              ...data,
              [field]: { src: base64Image.src, title: base64Image.title },
            },
          }),
        )
      }
    } else if (resource === 'newsletters') {
      // Update status to one of in_progress / completed when boolean is detected
      // this due to the fact that in DB values for this field are stored as enum
      if (typeof params.data.status === 'boolean') {
        params.data.status = params.data.status ? 'processed' : 'in-progress'
      }
      if (params.data.data.length) {
        const found = params.data.data.find(
          x =>
            x.type === 'Card / Image' ||
            x.type === 'Card / Image + Text' ||
            x.type === 'Card / Image + Text (no CTA)' ||
            x.type === 'Card / Akademie + header',
        )
        if (found) {
          const promises = []
          params.data.data.forEach(item => {
            if (
              (item.type === 'Card / Image' ||
                item.type === 'Card / Image + Text' ||
                item.type === 'Card / Image + Text (no CTA)' ||
                item.type === 'Card / Akademie + header') &&
              item.image &&
              item.image.rawFile instanceof File
            ) {
              promises.push(convertFileToBase64(item.image))
            }
          })
          return Promise.all(promises).then(values => {
            const newParams = Object.assign({}, params)
            newParams.data.data.forEach(item => {
              if (
                (item.type === 'Card / Image' ||
                  item.type === 'Card / Image + Text' ||
                  item.type === 'Card / Image + Text (no CTA)' ||
                  item.type === 'Card / Akademie + header') &&
                item.image &&
                item.image.rawFile instanceof File
              ) {
                const base64Image = values.find(x => x.rawFile === item.image.rawFile)
                item.image = { src: base64Image.src, title: base64Image.title }
              }
            })
            return requestHandler(type, resource, newParams)
          })
        }
      }
    }
  }

  return requestHandler(type, resource, params)
}

export default addUploadFeature



// WEBPACK FOOTER //
// ./api/addUpload.js